<template>
  <div
    v-if="show && port"
    class="customer-popup-overlay"
    @click.self="$emit('close')"
  >
    <div class="customer-popup-content">
      <!-- Header -->
      <div class="customer-popup-header">
        <div>
          <h3 class="customer-popup-title">{{ port.name }}</h3>
          <p class="customer-popup-subtitle">Port Details</p>
        </div>
        <button @click="$emit('close')" class="customer-popup-close" aria-label="Close">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
      
      <!-- Body -->
      <div class="customer-popup-body">
        <!-- Port Information -->
        <div class="port-stats-table">
            <table>
              <tbody>
                <tr>
                  <th style="color: var(--foreground) !important;">Foreign Imports</th>
                  <td>{{ formatNumber(port.foreign_imports) || '-' }}</td>
                </tr>
                <tr>
                  <th style="color: var(--foreground) !important;">Foreign Exports</th>
                  <td>{{ formatNumber(port.foreign_exports) || '-' }}</td>
                </tr>
                <tr>
                  <th style="color: var(--foreground) !important;">Domestic</th>
                  <td>{{ formatNumber(port.total_domestic) }}</td>
                </tr>
                <tr>
                  <th style="color: var(--foreground) !important;">Total Foreign</th>
                  <td>{{ formatNumber(port.total_foreign) }}</td>
                </tr>
                <tr>
                  <th style="color: var(--foreground) !important;">Total Trade</th>
                  <td>{{ formatNumber(port.total_trade) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        <!-- Trade Statistics -->
        
      </div>
      
      <!-- Footer -->
      <div class="customer-popup-footer">
        <button @click="$emit('close')" class="customer-popup-button">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PortPopup',
  
  props: {
    port: {
      type: Object,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  
  computed: {
    hasTradeData() {
      if (!this.port) return false;
      return this.port.foreign_imports || 
             this.port.foreign_exports || 
             this.port.total_domestic || 
             this.port.total_foreign || 
             this.port.total_trade;
    }
  },

  mounted() {
    document.addEventListener('keydown', this.handleEscKey);
  },
  
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleEscKey);
  },
  
  methods: {
    handleEscKey(event) {
      if (event.key === 'Escape' && this.show) {
        this.$emit('close');
      }
    },
    
    formatNumber(value) {
      if (value === null || value === undefined) return 'N/A';
      
      const num = parseInt(value);
      
      // Convert to millions with 1 decimal place
      const millions = num / 1000000;
      
      // Format with 1 decimal place and add 'M' suffix
      return millions.toFixed(1) + ' M';
    }
  }
};
</script>
